import React from "react";

const Footer = () => {
  return (
    <footer className="py-10 text-center text-xs text-neutral-500">
      © {new Date().getFullYear()} rapidito.uy - miyogur Lab
    </footer>
  );
};

export default React.memo(Footer);